import i18next from "i18next";
import { initReactI18next } from 'react-i18next';
import global_es from './es/global.json'

i18next.use(initReactI18next).init({
    lng: 'es',
    fallbackLng: 'es',
    resources: {
        es: {
            global: global_es,
            translation: global_es,
        },
    },
    interpolation: {
        escapeValue: false,
    },
});

export default i18next;